var product = function() {
	var speed;
	var first_special_change = false;
	function showDesc(t) {
		var goalHeight = t.find(".animate").height();
		t.addClass("showing");
		t.animate({
			height: goalHeight,
			marginTop: "5px"
		}, speed, function() {
			t.animate({
				opacity: 1
			}, speed * 0.6);
		});
	}

	function hideDesc(t) {
		t.removeClass("showing");
		t.animate({
			opacity: 0
		}, speed / 2, function () {
			t.animate({
				height: 0,
				marginTop: 0
			}, speed / 2);
		});
	}

	function setUniqueRef() {
		var min = 10000000000;
		var ref = Math.floor((Math.random() * min) + min);

		$("input[name='properties[Ref]']").val(ref);
	}

	function replaceInputFile() {
		var input = $("input[type=file]");
		input.css({
			height: 0,
			width: 0,
			overflow: "hidden",
		});
		var newlink = $("<a/>").attr("href", "#").addClass("file").html("U kunt hier uw Bestanden uploaden");
		input.after(newlink);
		//TODO: Add file in dutch
		$(document).on("click", ".file", function(e) {
			e.preventDefault();
			console.log("HELLO");
			$("input[type=file]").click();

		});
		$(document).on("change", "input[type=file]", function(e) {
			var file = $(this).val().split('\\').pop();
			console.log(file);
			if(file != "") {
				$(".file").html("Change file");
				var filename = $("<p/>").addClass("filename").html(file);
				$(".file").before(filename);
			} else {
				$(".filename").remove();
				$(".file").html("Add print file");
			}
		});

	}
	function setupEvents() {

		$(".product-option > .expandable").on("click", function() {
			var id = $(this).parent().attr("id");
			var desc = $(".desc-" + id);

			if(desc.hasClass("showing")) {
				$(this).find(".icon-down-arrow").addClass("icon-front-arrow").removeClass("icon-down-arrow");
				hideDesc(desc);
			} else {
				$(this).find(".icon-front-arrow").addClass("icon-down-arrow").removeClass("icon-front-arrow");
				showDesc(desc);
			}
		});

		$('.product-option-desc > .animate > .close').on("click", function() {
			var orgId = $(this).attr("id");
			var orgId = orgId.substr(6, orgId.length - 6);
			$("#" + orgId + " > .name > i").addClass("icon-front-arrow").removeClass("icon-down-arrow");
			hideDesc($(this).parent().parent());
		});

		$(".close").each(function() {
			$(this).find("img").attr("src", "//cdn.shopify.com/s/files/1/0239/3227/t/3/assets/description-close.gif?v=56409384140822942111442347637");
		});
	}

	function specialOption() {
		$(".product-option").each(function() {
			if($(this).hasClass("special")) {
				$(this).find("input").addClass("special-input");
				$(".extra-product-option1").find("input").each(function(i, o) {
					var v = $(o).val();
					$(o).parent().find("p").addClass("special-p").attr("org-value", v);
				});
				
				setAmount($(this).find("input:checked").val());
				$(document).on("change", ".special-input", function() {
					var v = $(this).val();
					console.log("Hello!");
					setAmount(v);
				});
			}
		});
	}

	function setAmount(amount) {
		$("input[name='properties[amountmultiplier]']").val(amount);
		$(".special-p").each(function(i, o) {

			var newNr = Number($(o).attr("org-value")) * amount;
			if(newNr != Number($(o).html()) && first_special_change) {
				$("#extra1").addClass('amount-red');
				setTimeout(function() {
					$('#extra1').removeClass('amount-red')
				}, 700);

			} 

			$(o).html(newNr);
			
		});
		first_special_change = true;
	}

	function moveDelivery() {
		if($("#delivery") !== undefined) {
			var del = $("#delivery");
			$("#delivery").remove();
			$("#ref").after(del);
		}
	}

	function init() {
		speed = 200;
		setUniqueRef();
		replaceInputFile();
		moveDelivery();
		setupEvents();
		setTimeout(specialOption, 50);
	}

	return {init:init};
}();